<app-file-upload-progress translatePrefix="notice.upload.submitting"
						  [progresses]="getProgresses()"
						  [generalProgress]="generalProgress"
						  (closeEvent)="reset()"/>
